"use client"

import { GetPageByRouteQuery } from "apollo"
import { Suspense } from "react"
import { getBreadCrumbs, transformProperties } from "utils"
import DynamicTitle from "../Common/DynamicTitle"
import Hero from "../Common/Hero"
import JobDisplay from "./JobDisplay"
import MultyUrl from "./MultyUrl"
import Recomendations from "./Recommendations"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  recomndationData: any
  jobResponse: any
}

export default function HeadquarterCareer({
  data,
  locale,
  recomndationData,
  jobResponse,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  const heroData = blocks?.blocks?.find(
    (block: any) => block.blockType === "heroBanner",
  )
  const adynamicTitleAndContant = blocks?.blocks?.find(
    (block: any) => block.blockType === "adynamicTitleAndContant",
  )
  const MultyURLsTitleAndText = blocks?.blocks?.find(
    (block: any) => block.blockType === "MultyURLsTitleAndText",
  )
  const recommendationsBlock = blocks?.blocks?.find(
    (block: any) => block.blockType === "recommendationsBlock",
  )
  const employeeRecommendations = blocks?.blocks?.find(
    (block: any) => block.blockType === "employeeRecommendations",
  )
  const showRecomndationData = recommendationsBlock || employeeRecommendations
  return (
    <>
      <Hero data={heroData} breadCrumbs={breadCrumbs} />
      <DynamicTitle data={adynamicTitleAndContant} />
      <Suspense>
        <JobDisplay jobResponse={jobResponse} />
      </Suspense>

      {MultyURLsTitleAndText && <MultyUrl data={MultyURLsTitleAndText} />}
      {recomndationData && showRecomndationData ? (
        <Recomendations data={recomndationData} />
      ) : null}
    </>
  )
}
